module.exports = __webpack_public_path__ + "static/media/eur.2430516b.svg";